"use strict";

require("./froala_3.0.5/js/froala_editor");

require("./froala_3.0.5/js/froala_editor.pkgd.js");

require("./froala_3.0.5/js/plugins/align.js");

require("./froala_3.0.5/js/plugins/code_beautifier.js");

require("./froala_3.0.5/js/plugins/code_view.js");

require("./froala_3.0.5/js/plugins/colors.js");

require("./froala_3.0.5/js/plugins/draggable.js");

require("./froala_3.0.5/js/plugins/emoticons.js");

require("./froala_3.0.5/js/plugins/entities.js");

require("./froala_3.0.5/js/plugins/font_family.js");

require("./froala_3.0.5/js/plugins/font_size.js");

require("./froala_3.0.5/js/plugins/forms.js");

require("./froala_3.0.5/js/plugins/fullscreen.js");

require("./froala_3.0.5/js/plugins/image.js");

require("./froala_3.0.5/js/plugins/line_breaker.js");

require("./froala_3.0.5/js/plugins/link.js");

require("./froala_3.0.5/js/plugins/lists.js");

require("./froala_3.0.5/js/plugins/paragraph_format.js");

require("./froala_3.0.5/js/plugins/paragraph_style.js");

require("./froala_3.0.5/js/plugins/quote.js");

require("./froala_3.0.5/js/plugins/save.js");

require("./froala_3.0.5/js/plugins/special_characters.js");

require("./froala_3.0.5/js/plugins/table.js");

require("./froala_3.0.5/js/plugins/url.js");

require("./froala_3.0.5/js/plugins/video.js");

require("./froala_3.0.5/js/plugins/line_height.js");

require("./froala_3.0.5/js/plugins/quick_insert.js");

require("./froala_3.0.5/js/plugins/help.js");

require("./froala_3.0.5/js/plugins/file.js");

require("./froala_3.0.5/js/plugins/print.js");

require("./froala_3.0.5/js/third_party/embedly.js");

require("./froala_3.0.5/js/third_party/font_awesome.js");

require("./customPlugins/cpAbbr.js");

require("./customPlugins/cpImage.js");

require("./customPlugins/cpDocument.js");

require("./customPlugins/cpHelpers.js");

require("./customPlugins/cpLang.js");

require("./customPlugins/cpQuote.js");

require("./froala_3.0.5/css/plugins/code_view.css");

require("./froala_3.0.5/css/plugins/colors.css");

require("./froala_3.0.5/css/plugins/draggable.css");

require("./froala_3.0.5/css/plugins/emoticons.css");

require("./froala_3.0.5/css/plugins/file.css");

require("./froala_3.0.5/css/plugins/fullscreen.css");

require("./froala_3.0.5/css/plugins/image.css");

require("./froala_3.0.5/css/plugins/image_manager.css");

require("./froala_3.0.5/css/plugins/line_breaker.css");

require("./froala_3.0.5/css/plugins/quick_insert.css");

require("./froala_3.0.5/css/plugins/special_characters.css");

require("./froala_3.0.5/css/plugins/table.css");

require("./froala_3.0.5/css/froala_editor.css");

require("./froala_3.0.5/css/froala_style.css");

require("./froala_3.0.5/css/font-awesome.css");

require("./froala_3.0.5/css/plugins/help.css");